export type MaterialType =
  | "aggregates"
  | "stone"
  | "sand"
  | "mulch"
  | "topsoil"
  | "clean-fill"
  | "general-fill"
  | "gravel"
  | "crushed-stone"
  | "recycled-concrete"
  | "contaminated-soil"
  | "other";

export type QualityTier =
  | "unrestricted"
  | "residential"
  | "commercial"
  | "industrial"
  | "restricted";

export type ListingType = "source" | "receiving";

export interface GeoLocation {
  lat: number;
  lng: number;
  address: string;
  city: string;
  state: "NY" | "NJ";
  zip: string;
}

export interface EnvironmentalData {
  qualityTier: QualityTier;
  labName: string;
  elapCertNumber: string;
  sampleDate: string;
  reportDate: string;
  standardsCompared: string[];
  exceedances: { parameter: string; result: number; standard: number; unit: string }[];
  passesNYPart375: boolean;
  passesNJRDCSRS: boolean;
}

export interface GeotechnicalData {
  moistureContent?: number;
  plasticityIndex?: number;
  liquidLimit?: number;
  gradation?: string;
  uscsClassification?: string;
}

export interface Listing {
  id: string;
  title: string;
  type: ListingType;
  materialType: MaterialType;
  qualityTier: QualityTier;
  quantity: number;
  unit: "tons" | "cubic-yards";
  pricePerUnit: number;
  location: GeoLocation;
  description: string;
  environmentalData?: EnvironmentalData;
  geotechnicalData?: GeotechnicalData;
  photos: string[];
  postedBy: string;
  companyName: string;
  postedDate: string;
  available: boolean;
}

export interface Trucker {
  id: string;
  companyName: string;
  contactName: string;
  phone: string;
  email: string;
  location: GeoLocation;
  fleetSize: number;
  truckTypes: string[];
  nyPermits: boolean;
  njPermits: boolean;
  insuranceCoverage: number;
  dotNumber: string;
  mcNumber: string;
  prequalified: boolean;
  rating: number;
  completedJobs: number;
}

export interface RegulatoryStandard {
  id: string;
  name: string;
  state: "NY" | "NJ";
  category: string;
  parameters: { name: string; unrestricted: number; residential: number; commercial: number; industrial: number; unit: string }[];
}

export type UserRole = "seller" | "buyer" | "trucker" | "consultant";

export const MATERIAL_LABELS: Record<MaterialType, string> = {
  aggregates: "Aggregates",
  stone: "Stone",
  sand: "Sand",
  mulch: "Mulch",
  topsoil: "Topsoil",
  "clean-fill": "Clean Fill",
  "general-fill": "General Fill",
  gravel: "Gravel",
  "crushed-stone": "Crushed Stone",
  "recycled-concrete": "Recycled Concrete",
  "contaminated-soil": "Contaminated Soil",
  other: "Other",
};

export const QUALITY_LABELS: Record<QualityTier, string> = {
  unrestricted: "Unrestricted Use",
  residential: "Residential Use",
  commercial: "Commercial Use",
  industrial: "Industrial Use",
  restricted: "Restricted / Requires Review",
};
